import { Component, OnInit, Renderer2 } from "@angular/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {}

  private scrollToElement(id: string, event: Event) {
    event.preventDefault();

    const element = document.getElementById(id);

    if (element) {
      const isMobile = window.innerWidth <= 768;
      const offset = isMobile ? 100 : 130;

      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - offset,
        behavior: "smooth",
      });
    }
  }

  public scrollToCursos(event: Event) {
    this.scrollToElement("cursos", event);
  }

  public scrollToWhyChoose(event: Event) {
    this.scrollToElement("why-choose", event);
  }

  public scrollToCareer(event: Event) {
    this.scrollToElement("career", event);
  }
}
